import React, { useState } from 'react';
import {
  TableHead,
  TableRow,
  TableCell,
  Dialog,
  IconButton
} from '@material-ui/core';
import { DeleteRounded, AddCircle } from '@material-ui/icons';
import InlineTable from '@/module/common/component/InlineTable';
import TableCellFilted from '@/module/common/componentUI/TableCellFilted';
import AutocompleteModal from '@/module/common/component/AutocompleteModal';
import { ButtonEnhance } from '@/module/common/componentUI/commonStyleComponents';
import { profileColumn } from '../constants';
import { TableWrapped } from '@/module/company/component/CompanyPaper/styled';
import globalDispatcher from '@/redux/global/actions';
import styled from 'styled-components';

const ProfileInformation = ({ formValue, setFormValue }) => {
  const [hiddenRows, setHiddenRows] = useState({});
  const [showModal, setShowModal] = useState(false);

  const onCloseModal = () => {
    setShowModal(false);
  };

  const onAddNewTest = data => {
    const lstOldProfiles = formValue.lstOldProfiles.concat(data);
    setFormValue({ ...formValue, lstOldProfiles });
    setShowModal(false);
  };

  const onDeleteTest = index => {
    let lstOldProfiles = [...formValue.lstOldProfiles];
    lstOldProfiles.splice(index, 1);
    setFormValue({ ...formValue, lstOldProfiles });
  };

  const TableCellFiltedWrapper = ({ ...props }) => (
    <TableCellFilted
      {...{
        hiddenRows,
        setHiddenRows
      }}
      {...props}
    />
  );
  const TableHeader = () => (
    <TableHead>
      <TableRow>
        {profileColumn.map(item =>
          item.label ? (
            <TableCellFiltedWrapper
              key={item.stateValue}
              label={item.label}
              stateValue={item.stateValue}
            />
          ) : (
            <TableCell key={item.stateValue}></TableCell>
          )
        )}
      </TableRow>
    </TableHead>
  );

  const TableFooter = () => (
    <StyledButtonEnhance
      background="#EFDFEB"
      color="#AD5E99"
      backgroundHover="#EFDFEB"
      onClick={() => setShowModal(true)}
    >
      <div className="add-group">
        <span>Add new profile</span>
        <AddCircle />
      </div>
    </StyledButtonEnhance>
  );

  const renderRow = onDeleteTest => (row, i, onDeleteValue) => (
    <>
      <TableCell>{!hiddenRows.name && row.name}</TableCell>
      <TableCell>{!hiddenRows.code && row.code}</TableCell>
      <TableCell>{!hiddenRows.totalTests && row.totalTests}</TableCell>
      <TableCell>{!hiddenRows.totalProfiles && row.totalProfiles}</TableCell>
      <TableCell align="right">
        <IconButton
          className="delete-icon"
          onClick={() => (onDeleteTest ? onDeleteTest(i) : onDeleteValue(i))}
        >
          <DeleteRounded />
        </IconButton>
      </TableCell>
    </>
  );

  return (
    <TableWrapped>
      <InlineTable
        Header={TableHeader}
        data={formValue.lstOldProfiles}
        Footer={TableFooter}
        noDataHelperText='Click button "Add new profile" to create new one'
        renderRow={renderRow(onDeleteTest)}
      />
      <Dialog maxWidth="lg" open={showModal} onClose={onCloseModal}>
        <AutocompleteModal
          onClose={onCloseModal}
          title="Profiles"
          optionLabel="name"
          textFieldPlaceholder="Select profile"
          onSubmit={onAddNewTest}
          Header={TableHeader}
          renderRow={renderRow()}
          getListOptions={globalDispatcher.getListProfiles}
          existedOption={formValue.lstOldProfiles}
        />
      </Dialog>
    </TableWrapped>
  );
};

export const StyledButtonEnhance = styled(ButtonEnhance)`
  display: flex;
  justify-content: center;
  max-width: 200px;
  float: right;
  margin-top: 15px;
  height: 35px;
  padding: 8px 16px;
  .add-group {
    display: flex;
    width: fit-content;
    align-items: center;
    margin-top: -2px;
    span {
      margin-right: 8px;
    }
  }
`;

export default ProfileInformation;
